import { render, staticRenderFns } from "./switchConfig.vue?vue&type=template&id=b37d5494&scoped=true&"
import script from "./switchConfig.vue?vue&type=script&lang=js&"
export * from "./switchConfig.vue?vue&type=script&lang=js&"
import style0 from "./switchConfig.vue?vue&type=style&index=0&id=b37d5494&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37d5494",
  null
  
)

export default component.exports